import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=19d0ff06&scoped=true&"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetails.vue?vue&type=style&index=0&id=19d0ff06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d0ff06",
  null
  
)

export default component.exports